import React, { FC, useState } from 'react'

import { Input, InputProps } from '../Input'

export type NumberProps = Omit<InputProps, 'value' | 'onChange'> & {
  value?: number | null
  onChange: (v: number | null) => void
  isNatural?: boolean
}

export const NumberInput: FC<NumberProps> = ({
  value = null,
  onChange,
  isNatural = false,
  ...props
}) => {
  const [input, setInput] = useState(value ? `${value}` : '')
  return (
    <Input
      inputMode="decimal"
      {...props}
      onChange={(e: any) => {
        const nextInput = isNatural
          ? e.target.value.replace(/\D+/g, '')
          : e.target.value
        setInput(nextInput)
        onChange(nextInput.trim().length === 0 ? null : parseFloat(nextInput))
      }}
      value={input}
    />
  )
}
